(function () {
  'use strict';


  /* =========================================================
     THE FUR — SEARCH OVERLAY
  ========================================================= */

  function initFurSearchOverlay() {

    const overlay =
      document.querySelector(
        '[data-fur-search-overlay]'
      );


    if (!overlay) {
      return;
    }


    if (
      overlay.dataset.furSearchInitialized ===
      'true'
    ) {
      return;
    }


    overlay.dataset.furSearchInitialized =
      'true';


    /* =====================================================
       ELEMENTS
    ===================================================== */

    const inner =
      overlay.querySelector(
        '[data-fur-search-inner]'
      );


    const form =
      overlay.querySelector(
        '[data-fur-search-form]'
      );


    const input =
      overlay.querySelector(
        '[data-fur-search-input]'
      );


    const closeButtons =
      overlay.querySelectorAll(
        '[data-fur-search-close]'
      );


    const initialState =
      overlay.querySelector(
        '[data-fur-search-initial]'
      );


    const resultsState =
      overlay.querySelector(
        '[data-fur-search-results-state]'
      );


    const emptyState =
      overlay.querySelector(
        '[data-fur-search-empty-state]'
      );


    const resultsGrid =
      overlay.querySelector(
        '[data-fur-search-results-grid]'
      );


    const resultsCount =
      overlay.querySelector(
        '[data-fur-search-results-count]'
      );


    const emptyCount =
      overlay.querySelector(
        '[data-fur-search-empty-count]'
      );


    const loading =
      overlay.querySelector(
        '[data-fur-search-loading]'
      );


    if (
      !input ||
      !initialState ||
      !resultsState ||
      !emptyState ||
      !resultsGrid
    ) {

      console.warn(
        'THE FUR SEARCH: Required elements are missing.'
      );


      return;
    }


    /* =====================================================
       SETTINGS
    ===================================================== */

    const DEBOUNCE_TIME =
      280;


    const RESULT_LIMIT =
      10;


    /* =====================================================
       STATE
    ===================================================== */

    let debounceTimer =
      null;


    let activeController =
      null;


    let requestNumber =
      0;


    let previousActiveElement =
      null;


    let savedScrollY =
      0;


    let isOpen =
      false;


    /* =====================================================
       ESCAPE HTML
    ===================================================== */

    function escapeHTML(value) {

      const element =
        document.createElement(
          'div'
        );


      element.textContent =
        value === null ||
        value === undefined
          ? ''
          : String(value);


      return element.innerHTML;
    }


    /* =====================================================
       MONEY

       /products/handle.js returns cents.
    ===================================================== */

    function formatMoney(value) {

      const number =
        Number(value);


      if (
        !Number.isFinite(number)
      ) {
        return '';
      }


      const amount =
        number / 100;


      const currency =
        window.Shopify?.currency?.active ||
        'PKR';


      try {

        return new Intl.NumberFormat(
          document.documentElement.lang ||
          'en-PK',
          {
            style: 'currency',
            currency: currency,
            maximumFractionDigits: 0
          }
        ).format(
          amount
        );

      } catch (error) {

        return (
          currency +
          ' ' +
          amount.toLocaleString()
        );
      }

    }


    /* =====================================================
       IMAGE SOURCE
    ===================================================== */

    function getImageSource(image) {

      if (!image) {
        return '';
      }


      if (
        typeof image ===
        'string'
      ) {
        return image;
      }


      return (
        image.src ||
        image.url ||
        ''
      );
    }


    /* =====================================================
       FETCH COMPLETE PRODUCT

       Predictive Search does not return enough data for:
       - 3 images
       - variants
       - product options
       - proper compare prices
    ===================================================== */

    async function getFullProduct(product) {

      if (
        !product ||
        !product.url
      ) {
        return product;
      }


      try {

        let cleanURL =
          product.url
            .split('?')[0]
            .replace(
              /\.js$/,
              ''
            );


        const response =
          await fetch(
            cleanURL + '.js',
            {
              method: 'GET',

              headers: {
                Accept:
                  'application/json'
              }
            }
          );


        if (!response.ok) {

          throw new Error(
            'Full product request failed.'
          );
        }


        const fullProduct =
          await response.json();


        return {
          ...product,
          ...fullProduct,

          url:
            cleanURL
        };

      } catch (error) {

        console.warn(
          'THE FUR SEARCH: Product JSON failed:',
          product?.title,
          error
        );


        return product;
      }

    }


    /* =====================================================
       FIRST THREE IMAGES
    ===================================================== */

    function getProductImages(product) {

      const images =
        [];


      if (
        Array.isArray(
          product.images
        )
      ) {

        product.images
          .slice(0, 3)
          .forEach(
            function (image) {

              const source =
                getImageSource(
                  image
                );


              if (source) {

                images.push(
                  source
                );
              }

            }
          );
      }


      /*
       * Predictive Search fallback.
       */

      if (
        !images.length &&
        product.featured_image
      ) {

        const source =
          getImageSource(
            product.featured_image
          );


        if (source) {

          images.push(
            source
          );
        }

      }


      if (
        !images.length &&
        product.image
      ) {

        const source =
          getImageSource(
            product.image
          );


        if (source) {

          images.push(
            source
          );
        }

      }


      return images;
    }


    /* =====================================================
       PRODUCT PRICE
    ===================================================== */

    function getPrice(product) {

      if (
        product.price !== undefined &&
        product.price !== null
      ) {

        const price =
          Number(
            product.price
          );


        if (
          Number.isFinite(price)
        ) {

          return price;
        }

      }


      if (
        Array.isArray(
          product.variants
        )
      ) {

        const prices =
          product.variants
            .map(
              function (variant) {

                return Number(
                  variant.price
                );

              }
            )
            .filter(
              Number.isFinite
            );


        if (prices.length) {

          return Math.min(
            ...prices
          );
        }

      }


      return 0;
    }


    /* =====================================================
       COMPARE PRICE
    ===================================================== */

    function getComparePrice(product) {

      if (
        product.compare_at_price !== undefined &&
        product.compare_at_price !== null
      ) {

        const compare =
          Number(
            product.compare_at_price
          );


        if (
          Number.isFinite(compare) &&
          compare > 0
        ) {

          return compare;
        }

      }


      if (
        Array.isArray(
          product.variants
        )
      ) {

        const prices =
          product.variants
            .map(
              function (variant) {

                return Number(
                  variant.compare_at_price
                );

              }
            )
            .filter(
              function (price) {

                return (
                  Number.isFinite(price) &&
                  price > 0
                );

              }
            );


        if (prices.length) {

          return Math.max(
            ...prices
          );
        }

      }


      return 0;
    }


    /* =====================================================
       AVAILABILITY
    ===================================================== */

    function productAvailable(product) {

      if (
        product.available !== undefined
      ) {

        return Boolean(
          product.available
        );
      }


      if (
        Array.isArray(
          product.variants
        )
      ) {

        return product.variants
          .some(
            function (variant) {

              return Boolean(
                variant.available
              );

            }
          );
      }


      return true;
    }


    /* =====================================================
       OPTION

       Prefer SIZE.
       Otherwise first real option.
    ===================================================== */

    function getProductOption(product) {

      if (
        !Array.isArray(
          product.options
        ) ||
        !product.options.length
      ) {
        return null;
      }


      const realOptions =
        product.options.filter(
          function (option) {

            const name =
              typeof option ===
              'string'
                ? option
                : option?.name;


            return (
              String(
                name || ''
              )
                .trim()
                .toLowerCase() !==
              'title'
            );

          }
        );


      if (!realOptions.length) {
        return null;
      }


      const sizeOption =
        realOptions.find(
          function (option) {

            const name =
              typeof option ===
              'string'
                ? option
                : option?.name;


            return (
              String(
                name || ''
              )
                .trim()
                .toLowerCase() ===
              'size'
            );

          }
        );


      return (
        sizeOption ||
        realOptions[0]
      );
    }


    /* =====================================================
       OPTION INDEX
    ===================================================== */

    function getOptionIndex(
      product,
      selectedOption
    ) {

      if (
        !Array.isArray(
          product.options
        )
      ) {
        return -1;
      }


      return product.options.findIndex(
        function (option) {

          if (
            option ===
            selectedOption
          ) {
            return true;
          }


          const optionName =
            typeof option ===
            'string'
              ? option
              : option?.name;


          const selectedName =
            typeof selectedOption ===
            'string'
              ? selectedOption
              : selectedOption?.name;


          return (
            String(optionName || '') ===
            String(selectedName || '')
          );

        }
      );
    }


    /* =====================================================
       OPTION VALUES
    ===================================================== */

    function getOptionValues(
      product,
      option
    ) {

      if (!option) {
        return [];
      }


      /*
       * Object structure with values.
       */

      if (
        typeof option ===
        'object' &&
        Array.isArray(
          option.values
        )
      ) {

        const values =
          option.values
            .map(
              function (value) {

                if (
                  value &&
                  typeof value ===
                  'object'
                ) {

                  return (
                    value.name ||
                    value.value ||
                    ''
                  );
                }


                return String(
                  value || ''
                );

              }
            )
            .filter(Boolean);


        return [
          ...new Set(
            values
          )
        ];
      }


      /*
       * /products/handle.js often returns:
       *
       * options:
       * ["Size", "Color"]
       *
       * Get values from variants.
       */

      if (
        Array.isArray(
          product.variants
        )
      ) {

        const optionIndex =
          getOptionIndex(
            product,
            option
          );


        if (
          optionIndex >= 0
        ) {

          const key =
            'option' +
            (
              optionIndex + 1
            );


          const values =
            product.variants
              .map(
                function (variant) {

                  return variant[
                    key
                  ];

                }
              )
              .filter(Boolean);


          return [
            ...new Set(
              values
            )
          ];
        }

      }


      return [];
    }


    /* =====================================================
       BUILD PRODUCT CARD

       IMPORTANT:
       These classes / data attributes match
       fur-product-card.liquid.
    ===================================================== */

    function createProductCard(product) {

      const title =
        escapeHTML(
          product.title || ''
        );


      const url =
        escapeHTML(
          product.url || '#'
        );


      const images =
        getProductImages(
          product
        );


      const price =
        getPrice(
          product
        );


      const comparePrice =
        getComparePrice(
          product
        );


      const available =
        productAvailable(
          product
        );


      /* =================================================
         IMAGES
      ================================================== */

      const imageMarkup =
        images
          .slice(0, 3)
          .map(
            function (
              source,
              index
            ) {

              return `
                <img
                  src="${escapeHTML(source)}"
                  alt="${title}"
                  loading="lazy"

                  class="
                    fur-product-card__image
                    fur-product-card__image--slide
                    ${
                      index === 0
                        ? 'is-active'
                        : ''
                    }
                  "

                  data-product-card-image
                >
              `;

            }
          )
          .join('');


      /* =================================================
         PRICE
      ================================================== */

      let priceMarkup =
        '';


      if (
        comparePrice > price &&
        price > 0
      ) {

        priceMarkup = `
          <span
            class="
              fur-product-card__sale-price
            "
          >
            ${escapeHTML(
              formatMoney(
                price
              )
            )}
          </span>

          <s
            class="
              fur-product-card__compare-price
            "
          >
            ${escapeHTML(
              formatMoney(
                comparePrice
              )
            )}
          </s>
        `;

      } else {

        priceMarkup = `
          <span
            class="
              fur-product-card__regular-price
            "
          >
            ${escapeHTML(
              formatMoney(
                price
              )
            )}
          </span>
        `;
      }


      /* =================================================
         OPTIONS
      ================================================== */

      const selectedOption =
        getProductOption(
          product
        );


      const optionValues =
        getOptionValues(
          product,
          selectedOption
        );


      let optionsMarkup =
        '';


      if (
        optionValues.length
      ) {

        optionsMarkup = `
          <div
            class="
              fur-product-card__options
            "
          >

            ${optionValues
              .map(
                function (value) {

                  return `
                    <span
                      class="
                        fur-product-card__option
                      "
                    >
                      ${escapeHTML(
                        value
                      )}
                    </span>
                  `;

                }
              )
              .join('')}

          </div>
        `;

      } else {

        optionsMarkup = `
          <span
            class="
              fur-product-card__view-text
            "
          >
            VIEW PRODUCT
          </span>
        `;
      }


      /* =================================================
         BADGE
      ================================================== */

      let badgeMarkup =
        '';


      if (!available) {

        badgeMarkup = `
          <span
            class="
              fur-product-card__badge
              fur-product-card__badge--sold-out
            "
          >
            SOLD OUT
          </span>
        `;

      } else if (
        comparePrice > price &&
        price > 0
      ) {

        badgeMarkup = `
          <span
            class="
              fur-product-card__badge
              fur-product-card__badge--sale
            "
          >
            SALE
          </span>
        `;
      }


      /* =================================================
         FINAL MARKUP
      ================================================== */

      return `
        <article
          class="
            fur-product-card
            fur-search-overlay__product
          "

          data-fur-product-card
        >

          <a
            href="${url}"
            class="
              fur-product-card__link
            "
            aria-label="${title}"
          >

            <!-- ==========================================
                 MEDIA
            =========================================== -->

            <div
              class="
                fur-product-card__media
                fur-product-card__media--portrait
              "

              data-product-card-media
            >

              ${imageMarkup}

              ${badgeMarkup}

            </div>


            <!-- ==========================================
                 INFORMATION
            =========================================== -->

            <div
              class="
                fur-product-card__information
              "
            >

              <!-- DEFAULT -->

              <div
                class="
                  fur-product-card__default-information
                "
              >

                <h3
                  class="
                    fur-product-card__title
                  "
                >
                  ${title}
                </h3>


                <div
                  class="
                    fur-product-card__price
                  "
                >
                  ${priceMarkup}
                </div>

              </div>


              <!-- HOVER -->

              <div
                class="
                  fur-product-card__hover-information
                "
              >
                ${optionsMarkup}
              </div>

            </div>

          </a>

        </article>
      `;
    }


    /* =====================================================
       INITIALIZE REAL PRODUCT CARD JS

       IMPORTANT:

       Search does NOT create a separate animation.

       It calls your exact Collection product-card JS.
    ===================================================== */

    function initializeDynamicCards() {

      const cards =
        resultsGrid.querySelectorAll(
          '[data-fur-product-card]'
        );


      cards.forEach(
        function (card) {

          /*
           * Remove possible initialization flags
           * before handing them to the real card JS.
           */

          delete card.dataset
            .furProductCardInitialized;


          delete card.dataset
            .furInitialized;


          delete card.dataset
            .productCardInitialized;

        }
      );


      if (
        window.FurProductCards &&
        typeof window
          .FurProductCards
          .init ===
        'function'
      ) {

        window.FurProductCards.init(
          resultsGrid
        );

      } else {

        console.error(
          'THE FUR SEARCH: FurProductCards initializer is not available. Check fur-product-card.js.'
        );

      }

    }


    /* =====================================================
       STATES
    ===================================================== */

    function hideAllStates() {

      initialState.classList.remove(
        'is-active'
      );


      resultsState.classList.remove(
        'is-active'
      );


      emptyState.classList.remove(
        'is-active'
      );

    }


    /* =====================================================
       INITIAL STATE
    ===================================================== */

    function showInitialState() {

      hideAllStates();


      initialState.classList.add(
        'is-active'
      );


      resultsGrid.innerHTML =
        '';


      if (resultsCount) {

        resultsCount.textContent =
          '';
      }


      if (emptyCount) {

        emptyCount.textContent =
          '';
      }

    }


    /* =====================================================
       RESULTS
    ===================================================== */

    function showResultsState(
      products,
      query
    ) {

      hideAllStates();


      resultsState.classList.add(
        'is-active'
      );


      const total =
        products.length;


      if (resultsCount) {

        resultsCount.textContent =
          `[ ${total} ${
            total === 1
              ? 'RESULT'
              : 'RESULTS'
          } FOUND FOR YOUR SEARCH "${query.toUpperCase()}" ]`;

      }


      /* =================================================
         INSERT PRODUCT CARDS
      ================================================== */

      resultsGrid.innerHTML =
        products
          .map(
            createProductCard
          )
          .join('');


      /* =================================================
         CRITICAL

         Run exact same JS as Collection cards.
      ================================================== */

      window.requestAnimationFrame(
        function () {

          initializeDynamicCards();

        }
      );

    }


    /* =====================================================
       EMPTY
    ===================================================== */

    function showEmptyState(query) {

      hideAllStates();


      emptyState.classList.add(
        'is-active'
      );


      resultsGrid.innerHTML =
        '';


      if (emptyCount) {

        emptyCount.textContent =
          `[ NO RESULTS FOR "${query.toUpperCase()}" ]`;

      }

    }


    /* =====================================================
       LOADING
    ===================================================== */

    function setLoading(active) {

      if (!loading) {
        return;
      }


      loading.classList.toggle(
        'is-active',
        active
      );


      loading.setAttribute(
        'aria-hidden',
        active
          ? 'false'
          : 'true'
      );

    }


    /* =====================================================
       CANCEL SEARCH
    ===================================================== */

    function cancelActiveSearch() {

      if (
        activeController
      ) {

        activeController.abort();


        activeController =
          null;

      }

    }


    /* =====================================================
       SEARCH PRODUCTS
    ===================================================== */

    async function searchProducts(query) {

      const cleanQuery =
        query.trim();


      if (!cleanQuery) {

        cancelActiveSearch();


        setLoading(
          false
        );


        showInitialState();


        return;
      }


      cancelActiveSearch();


      activeController =
        new AbortController();


      requestNumber +=
        1;


      const thisRequest =
        requestNumber;


      setLoading(
        true
      );


      try {

        /* =================================================
           PREDICTIVE SEARCH
        ================================================== */

        const params =
          new URLSearchParams();


        params.set(
          'q',
          cleanQuery
        );


        params.set(
          'resources[type]',
          'product'
        );


        params.set(
          'resources[limit]',
          String(
            RESULT_LIMIT
          )
        );


        params.set(
          'resources[options][unavailable_products]',
          'last'
        );


        const root =
          window.Shopify
            ?.routes
            ?.root ||
          '/';


        const searchURL =
          root +
          'search/suggest.json?' +
          params.toString();


        const response =
          await fetch(
            searchURL,
            {
              method: 'GET',

              headers: {
                Accept:
                  'application/json'
              },

              signal:
                activeController.signal
            }
          );


        if (!response.ok) {

          throw new Error(
            'Search request failed.'
          );
        }


        const data =
          await response.json();


        /* =================================================
           STALE REQUEST
        ================================================== */

        if (
          thisRequest !==
          requestNumber
        ) {
          return;
        }


        const predictiveProducts =
          data?.resources
            ?.results
            ?.products ||
          [];


        /* =================================================
           NO RESULTS
        ================================================== */

        if (
          predictiveProducts.length === 0
        ) {

          setLoading(
            false
          );


          showEmptyState(
            cleanQuery
          );


          return;
        }


        /* =================================================
           FULL PRODUCTS

           Required for images 1/2/3 + options.
        ================================================== */

        const products =
          await Promise.all(
            predictiveProducts.map(
              function (product) {

                return getFullProduct(
                  product
                );

              }
            )
          );


        /* =================================================
           CHECK AGAIN FOR STALE REQUEST
        ================================================== */

        if (
          thisRequest !==
          requestNumber
        ) {
          return;
        }


        setLoading(
          false
        );


        if (
          products.length
        ) {

          showResultsState(
            products,
            cleanQuery
          );

        } else {

          showEmptyState(
            cleanQuery
          );
        }

      } catch (error) {

        if (
          error.name ===
          'AbortError'
        ) {
          return;
        }


        console.error(
          'THE FUR SEARCH:',
          error
        );


        setLoading(
          false
        );


        showEmptyState(
          cleanQuery
        );

      }

    }


    /* =====================================================
       DEBOUNCE
    ===================================================== */

    function queueSearch() {

      if (
        debounceTimer !==
        null
      ) {

        window.clearTimeout(
          debounceTimer
        );

      }


      const query =
        input.value.trim();


      if (!query) {

        cancelActiveSearch();


        setLoading(
          false
        );


        showInitialState();


        return;
      }


      debounceTimer =
        window.setTimeout(
          function () {

            debounceTimer =
              null;


            searchProducts(
              query
            );

          },
          DEBOUNCE_TIME
        );

    }


    /* =====================================================
       OPEN
    ===================================================== */

    function openSearch(event) {

      if (event) {

        event.preventDefault();

      }


      if (isOpen) {
        return;
      }


      isOpen =
        true;


      previousActiveElement =
        document.activeElement;


      savedScrollY =
        window.scrollY ||
        window.pageYOffset ||
        0;


      overlay.classList.add(
        'is-open'
      );


      overlay.setAttribute(
        'aria-hidden',
        'false'
      );


      document.documentElement
        .classList.add(
          'fur-search-open'
        );


      document.body
        .classList.add(
          'fur-search-open'
        );


      if (inner) {

        inner.scrollTop =
          0;

      }


      if (
        !input.value.trim()
      ) {

        showInitialState();

      }


      window.setTimeout(
        function () {

          input.focus();


          const length =
            input.value.length;


          try {

            input.setSelectionRange(
              length,
              length
            );

          } catch (error) {

            // Ignore.

          }

        },
        120
      );

    }


    /* =====================================================
       CLOSE
    ===================================================== */

    function closeSearch() {

      if (!isOpen) {
        return;
      }


      isOpen =
        false;


      cancelActiveSearch();


      if (
        debounceTimer !==
        null
      ) {

        window.clearTimeout(
          debounceTimer
        );


        debounceTimer =
          null;

      }


      setLoading(
        false
      );


      overlay.classList.remove(
        'is-open'
      );


      overlay.setAttribute(
        'aria-hidden',
        'true'
      );


      document.documentElement
        .classList.remove(
          'fur-search-open'
        );


      document.body
        .classList.remove(
          'fur-search-open'
        );


      window.requestAnimationFrame(
        function () {

          window.scrollTo(
            0,
            savedScrollY
          );

        }
      );


      window.setTimeout(
        function () {

          if (
            previousActiveElement &&
            typeof previousActiveElement.focus ===
            'function'
          ) {

            previousActiveElement.focus();

          }

        },
        50
      );

    }


    /* =====================================================
       OPEN SEARCH

       Header requires:

       data-fur-search-open
    ===================================================== */

    document.addEventListener(
      'click',
      function (event) {

        const trigger =
          event.target.closest(
            '[data-fur-search-open]'
          );


        if (!trigger) {
          return;
        }


        event.preventDefault();


        openSearch(
          event
        );

      }
    );


    /* =====================================================
       CLOSE BUTTON
    ===================================================== */

    closeButtons.forEach(
      function (button) {

        button.addEventListener(
          'click',
          function (event) {

            event.preventDefault();


            closeSearch();

          }
        );

      }
    );


    /* =====================================================
       INPUT
    ===================================================== */

    input.addEventListener(
      'input',
      queueSearch
    );


    /* =====================================================
       FORM SUBMIT
    ===================================================== */

    if (form) {

      form.addEventListener(
        'submit',
        function (event) {

          event.preventDefault();


          const query =
            input.value.trim();


          if (!query) {

            showInitialState();


            return;
          }


          if (
            debounceTimer !==
            null
          ) {

            window.clearTimeout(
              debounceTimer
            );


            debounceTimer =
              null;

          }


          searchProducts(
            query
          );

        }
      );

    }


    /* =====================================================
       ESC
    ===================================================== */

    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key === 'Escape' &&
          isOpen
        ) {

          event.preventDefault();


          closeSearch();

        }

      }
    );


    /* =====================================================
       FOCUS TRAP
    ===================================================== */

    overlay.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key !==
          'Tab' ||
          !isOpen
        ) {
          return;
        }


        const focusable =
          Array.from(
            overlay.querySelectorAll(
              `
                button:not([disabled]),
                input:not([disabled]),
                a[href],
                [tabindex]:not([tabindex="-1"])
              `
            )
          ).filter(
            function (element) {

              return (
                element.offsetWidth > 0 ||
                element.offsetHeight > 0
              );

            }
          );


        if (!focusable.length) {
          return;
        }


        const first =
          focusable[0];


        const last =
          focusable[
            focusable.length - 1
          ];


        if (
          event.shiftKey &&
          document.activeElement ===
          first
        ) {

          event.preventDefault();


          last.focus();

        } else if (
          !event.shiftKey &&
          document.activeElement ===
          last
        ) {

          event.preventDefault();


          first.focus();

        }

      }
    );


    /* =====================================================
       INITIAL
    ===================================================== */

    showInitialState();

  }


  /* =========================================================
     NORMAL LOAD
  ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initFurSearchOverlay,
      {
        once: true
      }
    );

  } else {

    initFurSearchOverlay();

  }


  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function () {

      const overlay =
        document.querySelector(
          '[data-fur-search-overlay]'
        );


      if (!overlay) {
        return;
      }


      if (
        overlay.dataset.furSearchInitialized !==
        'true'
      ) {

        initFurSearchOverlay();

      }

    }
  );

})();